import { Link } from 'react-router-dom';
import { getAllPosts } from '../content/blogContent';
import { Clock, ArrowRight } from 'lucide-react';

function Blog() {
    const posts = getAllPosts();

    return (
        <div className="container fade-in" style={{ maxWidth: '1200px', margin: '0 auto', padding: '2rem 1rem' }}>
            <header style={{ marginBottom: '3rem', textAlign: 'center' }}>
                <h1 style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>Mortgage Education & Resources</h1>
                <p style={{ fontSize: '1.25rem', color: 'var(--text-secondary)' }}>
                    Learn everything you need to know about home loans, mortgages, and smart financing strategies
                </p>
            </header>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))', gap: '2rem' }}>
                {posts.map((post) => (
                    <Link
                        key={post.id}
                        to={`/blog/${post.slug}`}
                        style={{ textDecoration: 'none', color: 'inherit' }}
                    >
                        <article
                            className="card"
                            style={{
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                transition: 'all 0.3s ease',
                                cursor: 'pointer',
                                border: '1px solid var(--border)'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-4px)';
                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = 'none';
                            }}
                        >
                            <div style={{ marginBottom: '0.75rem' }}>
                                <span
                                    style={{
                                        display: 'inline-block',
                                        padding: '0.25rem 0.75rem',
                                        backgroundColor: 'var(--primary-light)',
                                        color: 'var(--primary)',
                                        borderRadius: '4px',
                                        fontSize: '0.875rem',
                                        fontWeight: '600'
                                    }}
                                >
                                    {post.category}
                                </span>
                            </div>

                            <h2 style={{ fontSize: '1.5rem', marginBottom: '0.75rem', lineHeight: '1.3' }}>
                                {post.title}
                            </h2>

                            <p style={{ color: 'var(--text-secondary)', marginBottom: '1rem', flexGrow: 1 }}>
                                {post.description}
                            </p>

                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '1rem', borderTop: '1px solid var(--border)' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
                                    <Clock size={16} />
                                    <span>{post.readTime}</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: 'var(--primary)', fontWeight: '600', fontSize: '0.875rem' }}>
                                    <span>Read More</span>
                                    <ArrowRight size={16} />
                                </div>
                            </div>
                        </article>
                    </Link>
                ))}
            </div>

            <div className="card" style={{ marginTop: '3rem', backgroundColor: 'var(--primary-light)', border: 'none', textAlign: 'center' }}>
                <h3 style={{ marginTop: 0, color: '#1e293b' }}>Ready to Calculate Your Mortgage?</h3>
                <p style={{ marginBottom: '1.5rem', color: '#475569' }}>
                    Put your knowledge into action with our comprehensive mortgage calculator
                </p>
                <Link
                    to="/"
                    className="btn btn-primary"
                    style={{ display: 'inline-block', textDecoration: 'none' }}
                >
                    Use Calculator
                </Link>
            </div>
        </div>
    );
}

export default Blog;
